import { createIcon } from '@chakra-ui/react/icon'

const BiUpload = createIcon({
  displayName: 'BiUpload',
  viewBox: '0 0 24 24',
  path: [
    <path d="M11 15H13V9H16L12 4L8 9H11V15Z" fill="currentColor" />,
    <path d="M20 18H4V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H20V18Z" fill="currentColor" />,
  ],
})

export default BiUpload
